import React from 'react'

import { useStateValue } from '../../components/HOC/StateProvider'
import Subtotal from '../../components/Subtotal/Subtotal'
import CheckoutProduct from '../../components/CheckoutProduct/CheckoutProduct'

import './Checkout.scss'
import { DispatchTypes } from '../../store/reducer'
import { useHistory } from 'react-router-dom'
import { Link } from '@material-ui/core'

const Checkout = () => {
  const history = useHistory()
  const { state, dispatch } = useStateValue()
  const { basket, user } = state

  const emptyBasket = () => dispatch({ type: DispatchTypes.EMPTY_BASKET })
  const routeBackToHome = () => history.push('/')

  return (
    <div className='checkout'>
      <div className='checkout__left'>
        <img
          className='checkout__ad'
          src='https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg'
          alt='Ad'
        />

        <div>
          <h3>Hello, {user?.email}</h3>
          <h2 className='checkout__title'>Your shopping Basket</h2>

          <div className='checkout__items'>
            {basket.map(({ id, title, image, price, rating }) => (
              <CheckoutProduct id={id} title={title} image={image} price={price} rating={rating} />
            ))}
          </div>

          {!basket.length && (
            <div className='checkout__emptyBasket'>
              <h2>Your basket seems to be empty</h2>
              <button onClick={routeBackToHome}>Browse Market</button>
            </div>
          )}
        </div>
      </div>

      <div className='checkout__right'>
        <Subtotal />
        <button onClick={emptyBasket}>Empty Basket</button>
        {!!basket.length && (
          <div className='checkout__right__shopMore'>
            <h3>Want to add more items?</h3>
            <Link href='#' onClick={routeBackToHome}>
              <h3>Continue Browsing</h3>
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default Checkout
